module.exports = __webpack_public_path__ + "static/media/twitter.4b04d2a5.svg";